import { useRef } from "react";
import { motion } from "framer-motion";
import { IMG } from "../../data/site";
import { Photo, Reveal, useParallax } from "./primitives";

export default function QuoteBand() {
  const ref = useRef(null);
  const y = useParallax(ref, ["-10%", "10%"]);
  return (
    <section ref={ref} aria-label="Feeling more" data-testid="quote-band" className="relative flex min-h-[560px] items-end overflow-hidden bg-ink lg:h-[88vh] lg:items-center">
      <motion.div style={{ y }} className="absolute inset-x-0 -inset-y-[12%]">
        <Photo img={IMG.bw} sizes="100vw" className="h-full w-full object-cover" />
      </motion.div>
      <div aria-hidden className="absolute inset-0 bg-[linear-gradient(to_top,rgba(28,24,20,0.85),rgba(28,24,20,0.2)_60%)] lg:bg-[linear-gradient(to_right,rgba(28,24,20,0.75),rgba(28,24,20,0.1)_65%)]" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 py-20 sm:px-8 lg:px-12">
        <blockquote className="max-w-2xl">
          <Reveal>
            <p className="font-display text-[2.4rem] font-light leading-[1.05] text-ivory sm:text-6xl lg:text-7xl">
              This isn't about doing more.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-display text-2xl italic leading-snug text-[#F6D2BC] [text-shadow:0_1px_14px_rgba(20,16,12,0.5)] sm:text-3xl">
              It's about feeling more and from that place, life starts to move differently.
            </p>
          </Reveal>
        </blockquote>
      </div>
    </section>
  );
}
